import {gtag4} from '../../../utilities/analytics/tracking';
import {abroadInsuranceEnum} from '../CollaborationInsuranceBlock/abroadInsuranceGAEnum';

export function gaReportAbroadInsurance(step){
    switch (step) {
        case abroadInsuranceEnum.SuccessPage: 
        gtag4({
            event: 'TravelInsurance_Step1_SuccessPage',
            step: '1',
            action: 'SuccessPage',
          });
        break;
        
        case abroadInsuranceEnum.BannerImp: 
        gtag4({
            event: 'TravelInsurance_Step2_BannerImp',
            step: '2',
            action: 'BannerImp',
          });
        break;
        
        case abroadInsuranceEnum.BannerClick: 
        gtag4({
            event: 'TravelInsurance_Step3_BannerClick',
            step: '3',
            action: 'BannerClick',
          });
        break;

        case abroadInsuranceEnum.ApprovedInsuranceMessage:
            gtag4({
                event: 'TravelInsurance_Step4_ApprovedInsuranceMessage',
                step: '4',
                action: 'ApprovedInsuranceMessage',
              });
        break;

        case abroadInsuranceEnum.InfoButtonLobby:
            gtag4({
                event: 'TravelInsurance_Step5_InfoButtonLobby',
                step: '5',
                action: 'InfoButtonLobby',
                button: 'למידע נוסף',
              });
        break;

        case abroadInsuranceEnum.InsuranceExist:
            gtag4({
                event: 'TravelInsurance_Step6_InsuranceExist',
                step: '6',
                action: 'InsuranceExist',
              });
        break;

        case abroadInsuranceEnum.InfoButtonHullSheli:
            gtag4({
                event: 'TravelInsurance_Step7_InfoButtonHullSheli',
                step: '7',
                action: 'InfoButtonHullSheli',
                button: 'פרטים נוספים',
              });
        break;

        case abroadInsuranceEnum.AnotherInsButton:
            gtag4({
                event: 'TravelInsurance_Step8_AnotherInsButton',
                step: '8',
                action: 'AnotherInsButton',
                button: 'לרכישת ביטוח למנוי נוסף',
              });
        break;
        
        case abroadInsuranceEnum.PhoneField:
            gtag4({
                event: 'TravelInsurance_Step9_PhoneField',
                step: '9',
                action: 'PhoneField',
              });
        break;

        case abroadInsuranceEnum.PhoneContinueButton:
            gtag4({
                event: 'TravelInsurance_Step10_PhoneContinueButton',
                step: '10',
                action: 'PhoneContinueButton',
                button: 'המשך',
              });
        break;

        case abroadInsuranceEnum.CellocmCusOffer:
            gtag4({
                event: 'TravelInsurance_Step13_CellocmCusOffer',
                step: '13',
                action: 'CellocmCusOffer',
              });
        break;

        case abroadInsuranceEnum.CellocmCustomerOfferJoinButton:
            gtag4({
                event: 'TravelInsurance_Step14_CellocmCusOfferJoinButton',
                step: '14',
                action: 'CellocmCusOfferJoinButton',
                button: 'רוצים להצטרף?',
              });
        break;
    }

}